App.prototype.addProductVariationToCart = function (form) {
    // form can have file inputs so, form.ds
    var formData = form.serialize();
    if(formData.indexOf("quantity") === -1 || formData.indexOf("product_unique_id") === -1){
        return false;
    }

    $.publish('/product/add-to-cart/start');

    $.ajax({
        type: 'POST',
        url: App.prototype.apiAddress + 'basket',
        // dataType: "json",
        data: new FormData(form[0]),
        processData: false,
        contentType: false,
        success: function (response) {

            $.publish(
                '/product/added-to-cart',
                [
                    form[0].querySelector('[name="product_unique_id"]').value,
                    response,
                ]
            );

            App.prototype.notificationSuccess(translates.product_added_to_cart)
            App.prototype.buildCart(response);


            if (history.state) {

                history.back();

            } else {
                if ($('.modal').length) {

                    $('.modal').modal('hide');

                }
            }

            var redirect = productVariationForm.find("[name=redirect]");

            if (redirect.is(":checked")) {

                location.href = redirect.val();

            }

            if(typeof fbq !== 'undefined') {
                fbq(response.pixel.eventType, response.pixel.eventName, response.pixel.customData, response.pixel.eventData);
            }
        },
        error: function (response) {

            const error = response.responseJSON && response.responseJSON.error ? response.responseJSON.error : translates.product_add_to_cart_error;

            if (error.indexOf("Teslimat") !== -1) {

                $('.change-shop-area').trigger("click");

            }

            App.prototype.notificationError(error);

            $.publish('/product/add-to-cart/error');

        },
    });
};

var productVariationForm = $('.add-product-variation-to-cart-form');

$(document).on("click", '.add-product-variation-to-cart-form button[type=submit]', function (e) {

    const elForm = $(this).closest('form');

    if ($(this).hasClass("buy-now")) {

        elForm.find("[name=redirect]").prop("checked", true);

    } else {

        elForm.find("[name=redirect]").prop("checked", false);

    }

})

$(document).on('submit', '.add-product-variation-to-cart-form', function (e) {
    e.preventDefault();
    App.prototype.addProductVariationToCart($(this));
});

